export const joinItemsWithAnd = (arr: string[], andString: string) => {
  const listStart = arr.slice(0, -1).join(', ')
  const listEnd = arr.slice(-1)
  const conjuction = arr.length <= 1 ? '' : andString
  return [listStart, listEnd].join(conjuction)
}
